function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.8
},
/*#__PURE__*/
React.createElement("path", {
  d: "M15.582 13.774a3.116 3.116 0 00-2.92 2.043l-2.1-4.2 5.463-10.9a.492.492 0 10-.879-.441l-5.134 10.247L4.878.276a.492.492 0 00-.879.441l5.463 10.9-2.1 4.2a3.114 3.114 0 10-.16 2.51l.009-.012 2.8-5.6 2.8 5.6c0 .006.008.01.011.015a3.113 3.113 0 102.758-4.555zM4.435 19.02a2.131 2.131 0 112.13-2.131 2.134 2.134 0 01-2.13 2.127zm11.147 0a2.131 2.131 0 112.131-2.131 2.133 2.133 0 01-2.131 2.127z"
}),
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z"
}));

var SvgAlteration = function SvgAlteration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgAlteration, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Alteration.65a40606.svg";
export { ForwardRef as ReactComponent };